import SignupContentSwitcher from './SignupContentSwitcher';

export default function SignUp() {
  return (
    <>
      <SignupContentSwitcher />
    </>
  );
}
